<div class="row">
  <div class="col-sm-12 mb-0">
    <div class="col-sm-12 mb-0">
      @if (showAlertImmunologisch()) {
        <p class="tam-alert mb-def">
          <i [class]="iconAlertImmunologisch()"></i>
          <span [innerHTML]="'meldung.feld.praeparat.alert.immunologisch' | translate | marked:true"></span>
        </p>
      }
      @if (showAlertLieferEngpass()) {
        <p class="tam-alert mb-def">
          <i [class]="iconAlertLieferEngpass()"></i>
          <span [innerHTML]="'meldung.feld.praeparat.alert.lieferEngpass' | translate | marked:true | injectUrl:'url.lieferEngpass'"></span>
        </p>
      }
    </div>
  </div>
</div>
@if (selectedDokumente().length) {
  <table class="dokument-table mb-15">
    @for (dokument of selectedDokumente(); track dokument.id) {
      <tr>
        <td>{{ dokument.typ.messageProperty | translate }}</td>
        <td>
          <a class="cursor-pointer" (click)="downloadDokument(dokument)">
            {{ dokument.name }}
          </a>
        </td>
        <td>
          <span class="glyphicon glyphicon-trash cursor-pointer"
             [matTooltip]="'global.tooltip.dokument.loeschen' | translate" matTooltipPosition="right"
             (click)="deleteDokument(dokument)" tabindex="0"></span>
        </td>
      </tr>
    }
  </table>
}
@if (availableUploads().length) {
  <div class="row" [ngClass]="{'has-error': errorMessage().length}" tabindex="-1" #focusAfterUpload>
    <div class="col-sm-12 mb-0">
      <div class="col-sm12 mb-0">
        <input class="hidden" type="file" [accept]="'dokument.extensions' | setting" (change)="uploadDokument($event)" #fileInput>
        @for (dokumentTyp of availableUploads(); track dokumentTyp.id) {
          <button class="btn btn-default ml-15" (click)="$event.preventDefault(); selectDokument(dokumentTyp)">{{ dokumentTyp.messageProperty | translate }}</button>
        }
      </div>
      @for (msg of errorMessage(); track msg) {
        <div class="col-sm-12 mb-0 help-block" role="alert">{{ msg }}</div>
      }
    </div>
  </div>
}
